import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import BcSnackbar, { CBcSnackbar } from '@/components/BcSnackbar.vue';
import BcDialog, { CBcDialog, CBcDialogForm } from '@/components/Dialog.vue';
const { EleResize } = require('@/assets/js/eresize.js');
class UserForm extends CBcDialogForm {
    constructor(form) {
        super();
        const that = this;
        if (form) {
            Object.keys(form).forEach((k) => {
                that[k] = form[k];
            });
        }
    }
}
var EDeviceType;
(function (EDeviceType) {
    EDeviceType["All"] = "";
    EDeviceType["Xilin"] = "xilin";
    EDeviceType["Ampul"] = "ampul";
    EDeviceType["Auto"] = "auto";
})(EDeviceType || (EDeviceType = {}));
let StatisticDispense = class StatisticDispense extends Vue {
    constructor() {
        super();
        this.pageLoading = {
            total: {
                months: false,
            },
            xilin: {
                months: false,
                category: false,
                module: false,
            },
            ampul: {
                months: false,
                category: false,
                module: false,
            },
            comp: {
                months: false,
                category: false,
                module: false,
            }
        };
        this.display = {
            xilin: true,
            ampul: true,
            comp: false
        };
        this.dialog = new CBcDialog(new UserForm());
        this.snackbar = new CBcSnackbar();
        this.disMonthsOp = ['all', 'xilin', 'ampul', 'auto']
            .map((v, i) => ({ dataType: v,
            title: {
                show: false,
                textStyle: {
                    color: '#bcbcbc'
                },
                text: '没有数据',
                left: 'center',
                top: 'center',
            },
            color: ['#5793f3', '#d14a61', '#675bba'],
            tooltip: {
                trigger: 'axis'
            },
            toolbox: {
                feature: {
                    dataView: { show: true, readOnly: false },
                    restore: { show: true },
                    saveAsImage: {}
                }
            }, xAxis: {
                type: 'category',
                axisTick: {
                    alignWithLabel: true
                },
                axisLine: {
                    lineStyle: {
                        color: '#5793f3'
                    }
                },
                axisPointer: {
                    label: {
                        formatter: (params) => `月份: ${params.value}`
                    }
                },
                data: []
            }, yAxis: [
                {
                    name: '故障数',
                    position: 'left',
                    silent: false,
                    splitLine: {
                        show: false
                    },
                    type: 'value',
                    axisLabel: {
                        formatter: '{value}'
                    }
                },
            ], series: [
                {
                    data: [],
                    name: '故障数',
                    type: 'line',
                    smooth: true,
                    animationDelay: (idx) => idx * 10,
                },
                {
                    type: 'bar',
                    barWidth: 1,
                    data: [],
                    itemStyle: {
                        normal: {
                            shadowBlur: 1,
                            color: (params) => {
                                const indexColor = params.value;
                                if (indexColor >= 99) {
                                    return '#45ef96';
                                }
                                else if (indexColor >= 90) {
                                    return '#ffed8b';
                                }
                                else {
                                    return '#ffb8af';
                                }
                            }
                        }
                    },
                    animationDelay: (idx) => idx * 10 + 100
                }
            ], animationEasing: 'elasticOut', animationDelayUpdate: (idx) => idx * 5, sourceData: [] }));
        this.disCategoryOp = ['xilin', 'ampul', 'auto']
            .map((v, i) => ({ dataType: v,
            color: ['#ff7f50', '#87cefa', '#61a0a8', '#d48265', '#91c7ae', '#749f83', '#ca8622', '#bda29a', '#6e7074', '#546570', '#c4ccd3'],
            title: {
                show: false,
                text: '',
                left: 'center',
                top: 20,
            },
            tooltip: {
                trigger: 'item',
                formatter: '{a} <br/>{b} : {c}个 ({d}%)'
            }, series: [
                {
                    name: '故障统计',
                    type: 'pie',
                    radius: '55%',
                    center: ['50%', '50%'],
                    data: [],
                    roseType: 'radius',
                    label: {
                        normal: {
                            // formatter: '{a|{a}}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ',
                            formatter: '{b|{b}：}{c}个\n{hr|}\n {per|{d}%}  ',
                            show: true,
                            rich: {
                                a: {
                                    color: '#999',
                                    lineHeight: 22,
                                    align: 'center'
                                },
                                hr: {
                                    borderColor: '#aaa',
                                    width: '100%',
                                    borderWidth: 0.5,
                                    height: 0
                                },
                                b: {
                                    fontSize: 16,
                                    lineHeight: 33
                                },
                                per: {
                                    color: '#eee',
                                    backgroundColor: '#334455',
                                    padding: [2, 4],
                                    borderRadius: 2
                                }
                            }
                        },
                        emphasis: {
                            show: true
                        }
                    },
                    animationType: 'scale',
                    animationEasing: 'elasticOut',
                    animationDelay: (idx) => Math.random() * 200
                }
            ]
        }));
        this.disModuleOp = ['xilin', 'ampul', 'auto']
            .map((v, i) => ({ dataType: v,
            color: ['#ff7f50', '#87cefa', '#61a0a8', '#d48265', '#91c7ae', '#749f83', '#ca8622', '#bda29a', '#6e7074', '#546570', '#c4ccd3'],
            tooltip: {
                trigger: 'item',
                formatter: '{a} <br/>{b} : {c}个 ({d}%)'
            },
            calculable: true, series: [
                {
                    name: '故障统计',
                    type: 'pie',
                    radius: '55%',
                    center: ['50%', '50%'],
                    data: [],
                    label: {
                        normal: {
                            formatter: '{b|{b}：}{c}个\n{hr|}\n {per|{d}%}  ',
                            show: true,
                            rich: {
                                a: {
                                    color: '#999',
                                    lineHeight: 22,
                                    align: 'center'
                                },
                                hr: {
                                    borderColor: '#aaa',
                                    width: '100%',
                                    borderWidth: 0.5,
                                    height: 0
                                },
                                b: {
                                    fontSize: 16,
                                    lineHeight: 33
                                },
                                per: {
                                    color: '#eee',
                                    backgroundColor: '#334455',
                                    padding: [2, 4],
                                    borderRadius: 2
                                }
                            }
                        },
                        emphasis: {
                            show: true
                        }
                    },
                    roseType: 'area',
                    animationType: 'scale',
                    animationEasing: 'elasticOut',
                    animationDelay: (idx) => Math.random() * 200
                }
            ]
        }));
        const that = this;
    }
    mounted() {
        const that = this;
        that.getMonthsData(EDeviceType.All, true);
        // // that.getDisTotalDeviceType()
        that.getMonthsData(EDeviceType.Xilin);
        that.getMonthsData(EDeviceType.Ampul);
        that.getCategoryData(EDeviceType.Xilin);
        that.getCategoryData(EDeviceType.Ampul);
        that.getModuleData(EDeviceType.Xilin);
        that.getModuleData(EDeviceType.Ampul);
    }
    drawLine(dom, option) {
        const that = this;
        const doc = document;
        const eleResize = EleResize;
        const myChart = that.$echarts.init(doc.getElementById(dom));
        const resizeDiv = doc.getElementById(dom);
        // 绘制图表
        myChart.setOption(option);
        eleResize.on(resizeDiv, () => myChart.resize());
    }
    async getDispenseSummary(op) {
        const that = this;
        const params = {};
        // ['台式西林设备', '台式安瓿设备', '综合配药设备']
        if (op && op.deviceType)
            params['deviceType'] = /西林|xilin/i.test(op.deviceType) ? '台式西林设备' : /安瓿|ampul/i.test(op.deviceType) ? '台式安瓿设备' : '综合配药设备';
        if (op && op.group)
            params['group'] = op.group;
        const resd = await that.axios.get('/api/report/malfunction/summary', { params: params });
        return resd && resd.data || { result: [] };
    }
    getDeviceTypeKey(deviceType) {
        return deviceType === EDeviceType.Xilin ? '台式西林设备' : deviceType === EDeviceType.Ampul ? '台式安瓿设备' : deviceType === EDeviceType.Auto ? '综合配药设备' : '';
    }
    async handleChartsData(op, isAll) {
        const that = this;
        let pageLoadingKey = 'total';
        let groupKey = 'months';
        try {
            const deviceType = op && op.deviceType;
            const group = op && op.group;
            const isCategoryGroup = /category/i.test(group);
            const isModuleGroup = /module/i.test(group);
            const isHospitalGroup = /hospital/i.test(group);
            const isDeviceGroup = /device/i.test(group);
            const isXilinType = /西林|xilin/i.test(deviceType);
            const isAmpulType = /安瓿|ampul/i.test(deviceType);
            const isAutoType = /综合|auto/i.test(deviceType);
            const yKey = 'total'; // isRateType ? 'rate' : 'total'
            const xKey = isCategoryGroup ? 'category' : isModuleGroup ? 'module' : isHospitalGroup ? 'hospital' : isDeviceGroup ? 'device' : 'date';
            let dataTypeIndex = isXilinType ? 1 : isAmpulType ? 2 : isAutoType ? 3 : 0;
            if (!isAll && dataTypeIndex > 0)
                dataTypeIndex -= 1;
            pageLoadingKey = isXilinType ? 'xilin' : isAmpulType ? 'ampul' : isAutoType ? 'auto' : 'total';
            groupKey = isCategoryGroup ? 'category' : isModuleGroup ? 'module' : isDeviceGroup ? 'device' : isHospitalGroup ? 'hospital' : 'months';
            const domKey = `chart_malfunction_${isXilinType ? 'xilin' : isAmpulType ? 'ampul' : isAutoType ? 'auto' : 'total'}_${groupKey}`;
            const typeKey = isCategoryGroup ? 'disCategoryOp' : isModuleGroup ? 'disModuleOp' : 'disMonthsOp';
            that.pageLoading[pageLoadingKey][groupKey] = true;
            const res = await that.getDispenseSummary(op);
            const isPipe = /pie/i.test(that[typeKey][dataTypeIndex]['series'][0].type);
            that[typeKey][dataTypeIndex]['sourceData'] = isPipe ? res.result.map((v) => ({ value: v.total, name: v[isCategoryGroup ? 'category' : 'module'] })) : res.result.map((v) => v[yKey]);
            that[typeKey][dataTypeIndex]['series'][0]['data'] = that[typeKey][dataTypeIndex]['sourceData'];
            if (!isPipe) {
                that[typeKey][dataTypeIndex]['xAxis']['data'] = res.result.map((v) => v[xKey]);
                that[typeKey][dataTypeIndex]['series'][1]['data'] = that[typeKey][dataTypeIndex]['sourceData'];
            }
            that.pageLoading[pageLoadingKey][groupKey] = false;
            if (that[typeKey][dataTypeIndex]['sourceData'].length)
                that.$nextTick(() => that.drawLine(domKey, that[typeKey][dataTypeIndex]));
        }
        catch (e) {
            that.pageLoading[pageLoadingKey][groupKey] = false;
            console.log('error of get handleChartsData months.', e);
            that.snackbar.error('处理汇总数据过程出错');
        }
    }
    async getMonthsData(deviceType, isAll) {
        const that = this;
        try {
            await that.handleChartsData({ deviceType: that.getDeviceTypeKey(deviceType) }, isAll);
        }
        catch (e) {
            console.log('error of get dispense summary months.', e);
            that.snackbar.error('加载月配药汇总数据过程出错');
        }
    }
    async getCategoryData(deviceType) {
        const that = this;
        try {
            await that.handleChartsData({ deviceType: that.getDeviceTypeKey(deviceType), group: 'category' });
        }
        catch (e) {
            console.log('error of get dispense summary hospital.', e);
            that.snackbar.error('加载各地配药汇总数据过程出错');
        }
    }
    async getModuleData(deviceType) {
        const that = this;
        try {
            await that.handleChartsData({ deviceType: that.getDeviceTypeKey(deviceType), group: 'module' });
        }
        catch (e) {
            console.log('error of get dispense summary device.', e);
            that.snackbar.error('加载各机器配药汇总数据过程出错');
        }
    }
};
__decorate([
    Getter
], StatisticDispense.prototype, "userInfo", void 0);
StatisticDispense = __decorate([
    Component({
        name: 'StatisticDispense',
        components: {
            BcSnackbar,
            BcDialog,
        },
    })
], StatisticDispense);
export default StatisticDispense;
;
